export default "__VITE_ASSET__Du6er9bE__"